import moment from 'moment';

export default class DataConvertUtils {
  private static _instance: DataConvertUtils;

  private constructor() {}

  public static get instance(): DataConvertUtils {
    if (this._instance === undefined) {
      this._instance = new DataConvertUtils();
    }
    return this._instance;
  }

  public getIdByKey(key: string, array: Array<any>): string | number {
    let id: string | number = '';
    for (let i = 0; i < array.length; i++) {
      const element = array[i];
      if (key === element.key) {
        id = element.id;
        break;
      }
    }
    return id;
  }

  public getIdFromName(name: string, array: Array<any>) {
    const itemList = array.find(item => item.name == name);
    return itemList && itemList.id ? itemList.id : '';
  }

  public getObjectFromArrayById(id: number | string, array: Array<any>): any {
    let object: any = null;
    for (let i = 0; i < array.length; i++) {
      const element = array[i];
      if (element.id == id) {
        object = element;
        break;
      }
    }
    return object;
  }


  public formatMoney(value) {
    value = value.toString();
    if (value.includes('.')) {
      value = value.split('.').join('');
    }
    if (value.includes(',')) {
      value = value.split(',').join('');
    }
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  public convertDataTable(data: Array<any>): Array<any> {
    let dataTable: Array<any> = [];
    dataTable = data.map((element, index) => {
      element.index = index + 1;
      return element;
    });
    return dataTable;
  }

  public formaterNumberHaveDots(number: number | any) {
    if (!number && number != 0) return '';
    let isInteger = Number.isInteger(Number(number));
    number = Number(number).toFixed(3);
    // number = number.replace(".", ",");
    if (number || number == 0) {
      const numberString = number.toString();
      if (numberString) {
        let numberFloat = numberString.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
        let findIndexDotEnd = numberFloat.lastIndexOf('.');
        let firstNumber = numberFloat.slice(0, findIndexDotEnd);
        let endNumber = numberFloat.slice(findIndexDotEnd + 1, numberFloat.length - 1);
        if (!isInteger) {
          return `${firstNumber || ''},${endNumber || ''}`;
        } else {
          return `${firstNumber || ''}`;
        }
      }
      if (numberString === '0') {
        return '0';
      }
      return '';
    }
    return '';
  }

  public convertQueryArrayToArray(queryArray, type?: string) {
    let newArray = [];

    if (typeof queryArray == 'object') {
      newArray = queryArray;
      newArray = newArray.map(item => Number(item));
    } else {
      newArray = [Number(queryArray)];
    }
    return newArray;
  }
  public addSTTArrayNotPag(array: Array<any>) {
    array = array.map((item, index) => {
      item.stt_index = index + 1;
      return item;
    });
    return array;
  }
  public convertRouterNameToReportTagId(name: string): string {
    if (name === 'VT01') {
      return 'VT01';
    } else if (name === 'VT02-1') {
      return 'VT02.1';
    } else if (name === 'VT03-1') {
      return 'VT03.1';
    } else if (name === 'VT04-1') {
      return 'VT04.1';
    } else if (name === 'VT05-1') {
      return 'VT05.1';
    } else if (name === 'VT06-1') {
      return 'VT06.1';
    } else if (name === 'VT07-1') {
      return 'VT07.1';
    } else if (name === 'VT08-1') {
      return 'VT08.1';
    } else if (name === 'VT09') {
      return 'VT09';
    } else if (name === 'VT10') {
      return 'VT010';
    } else {
      return '';
    }
  }
  public getTenYears(): Array<number> {
    const tenYears: Array<number> = [];
    const now = new Date();
    for (let i = 0; i < 10; i++) {
      tenYears.push(now.getFullYear() - i);
    }
    return tenYears;
  }
  public convertDateToISOString(date) {
    const dataFormat = moment(date).format('YYYY-MM-DD');
    return new Date(dataFormat).toISOString();
  }
  public convertDateToISOStringEND(date) {
    const dataFormat = moment(date).format('YYYY-MM-DD');
    return new Date(dataFormat + 'T23:59:59Z').toISOString();
  }
  public getOptionDisableDateLessThan(dateInput: Date | string): object {
    const date: Date = typeof dateInput === 'string' ? new Date(dateInput) : dateInput;
    const ONE_DAY_TIME = 8.64e7;
    return {
      disabledDate(time: Date) {
        return time.getTime() < date.getTime() - ONE_DAY_TIME;
      },
    };
  }
  public getOptionDisableDateLessThanAndGreatThan(dateLessThan: Date | string, dateGreatThan: Date | string): object {
    const lessThanTime: Date = typeof dateLessThan === 'string' ? new Date(dateLessThan) : dateLessThan;
    const greatThanTime: Date = typeof dateGreatThan === 'string' ? new Date(dateGreatThan) : dateGreatThan;
    const ONE_DAY_TIME = 8.64e7;
    return {
      disabledDate(time: Date) {
        return time.getTime() < lessThanTime.getTime() - ONE_DAY_TIME || time.getTime() > greatThanTime.getTime();
      },
    };
  }
  /**
   * name
   */
  public onlyUnique(value: any, index: any, self: any) {
    return self.indexOf(value) === index;
  }
}
